module.exports = __webpack_public_path__ + "files/67fd1703dc0d474bf2617934ca9d5ead.png";